import apiClient from './apiClient';

export const rentalApi = {
    // Items
    getItems: async () => {
        const response = await apiClient.get('/api/rental/items');
        return response.data;
    },
    createItem: async (data) => {
        const response = await apiClient.post('/api/rental/items', data);
        return response.data;
    },
    updateItem: async (id, data) => {
        const response = await apiClient.patch(`/api/rental/items/${id}`, data);
        return response.data;
    },
    deleteItem: async (id) => {
        const response = await apiClient.delete(`/api/rental/items/${id}`);
        return response.data;
    },

    // Customers
    getCustomers: async () => {
        const response = await apiClient.get('/api/rental/customers');
        return response.data;
    },
    createCustomer: async (data) => {
        const response = await apiClient.post('/api/rental/customers', data);
        return response.data;
    },

    // Rentals
    getRentals: async () => {
        const response = await apiClient.get('/api/rental');
        return response.data;
    },
    createRental: async (data) => {
        const response = await apiClient.post('/api/rental', data);
        return response.data;
    },
    getRentalDetails: async (id) => {
        const response = await apiClient.get(`/api/rental/${id}`);
        return response.data;
    },
    updateStatus: async (id, status) => {
        const response = await apiClient.patch(`/api/rental/${id}/status`, { status });
        return response.data;
    },
    updateRental: async (id, data) => {
        const response = await apiClient.patch(`/api/rental/${id}`, data);
        return response.data;
    },

    // Special
    getContract: async () => {
        const response = await apiClient.get('/api/rental/settings/contract');
        return response.data;
    },
    saveContract: async (contract_data) => {
        const response = await apiClient.post('/api/rental/settings/contract', { contract_data });
        return response.data;
    },
    getMasterVehicles: async () => {
        const response = await apiClient.get('/api/rental/master-vehicles');
        return response.data;
    },
    checkAvailability: async (itemId, startDate, endDate) => {
        const response = await apiClient.get('/api/rental/check-availability', {
            params: { item_id: itemId, start_date: startDate, end_date: endDate }
        });
        return response.data;
    }
};
